import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer } from './variants';

interface StaggerContainerProps {
    children: React.ReactNode;
    className?: string;
}

const StaggerContainer: React.FC<StaggerContainerProps> = ({ children, className }) => {
    return (
        <motion.div
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default StaggerContainer;
